"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubmitMenuOrderBodyToJSON = exports.SubmitMenuOrderBodyFromJSONTyped = exports.SubmitMenuOrderBodyFromJSON = void 0;
var runtime_1 = require("../runtime");
function SubmitMenuOrderBodyFromJSON(json) {
    return SubmitMenuOrderBodyFromJSONTyped(json, false);
}
exports.SubmitMenuOrderBodyFromJSON = SubmitMenuOrderBodyFromJSON;
function SubmitMenuOrderBodyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'hash': !(0, runtime_1.exists)(json, 'hash') ? undefined : json['hash'],
    };
}
exports.SubmitMenuOrderBodyFromJSONTyped = SubmitMenuOrderBodyFromJSONTyped;
function SubmitMenuOrderBodyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'hash': value.hash,
    };
}
exports.SubmitMenuOrderBodyToJSON = SubmitMenuOrderBodyToJSON;
